import { render, staticRenderFns } from "./calibrationLabMessageAdmin.vue?vue&type=template&id=4718c3fc&"
import script from "./calibrationLabMessageAdmin.vue?vue&type=script&lang=js&"
export * from "./calibrationLabMessageAdmin.vue?vue&type=script&lang=js&"
import style0 from "./calibrationLabMessageAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports